/**
 * Pagination — mandatory on invoice lists (design README S3 rule; ADR-000 §5
 * Q2: ~75k rows on a busy-branch 30-day range). Cursor-based per the frozen
 * contract (api.yaml aggInvoices). Position is always shown; infinite scroll
 * is banned for task data.
 */

import type { InvoicePage } from '@domain/types'

export function Pagination({
  page,
  onCursor,
}: {
  page: InvoicePage
  onCursor: (cursor: string) => void
}) {
  const count = page.invoices.length
  return (
    <nav className="pagination" data-testid="pagination" aria-label="Invoice list pages">
      <span className="page-position" data-testid="page-position">
        {count === 0 ? '0 invoices' : `Showing ${count} invoice${count === 1 ? '' : 's'} on this page`}
        {page.hasMore ? ' — more pages available' : ' — end of list'}
      </span>
      {page.hasMore && page.nextCursor !== null && (
        <button type="button" onClick={() => onCursor(page.nextCursor as string)} data-testid="next-page" className="next-page-button">
          Next page
        </button>
      )}
    </nav>
  )
}
